import React, { useEffect, useState } from "react";
import "../styles/Gallery.scss";

import img1 from "../assets/gallery/1.webp";
import img2 from "../assets/gallery/2.webp";
import img3 from "../assets/gallery/3.webp";
import img4 from "../assets/gallery/4.webp";
import img5 from "../assets/gallery/5.webp";
import img6 from "../assets/gallery/6.webp";
import img7 from "../assets/gallery/7.webp";
import img8 from "../assets/gallery/8.webp";

import g1 from "../assets/gallery/g1.webp";
import g2 from "../assets/gallery/g2.webp";
import g3 from "../assets/gallery/g3.webp";
import g4 from "../assets/gallery/g4.webp";

import h1 from "../assets/h1.png";

const Gallery = () => {
  const videos = [
    { title: "Wide Roads", img: g2 },
    { title: "Yoga", img: g3 },
    { title: "Morning Walks", img: g1 },
    { title: "Glimpse", img: img1 },
    { title: "Luxury Villa", img: img2 },
    { title: "Foggy Peaks", img: h1 },
    { title: "Misty Waterfalls", img: img3 },
    { title: "Luxury Living", img: g4 },
    { title: "Peace", img: img4 },
    { title: "Resort Lifestyle", img: img5 },
    { title: "Resort Style", img: img6 },
    { title: "Shirota Dam", img: img7 },
    { title: "Mountain Views", img: img8 },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev === videos.length - 1 ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [videos.length]);

  const prevSlide = () => {
    setActiveIndex((prev) =>
      prev === 0 ? videos.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setActiveIndex((prev) =>
      prev === videos.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section id="gallery" className="gallery-section">

      {/* Background Layer */}
      <div className="gallery-bg">
        <img
          src={videos[activeIndex].img}
          alt={videos[activeIndex].title}
          loading="lazy"
        />
      </div>

      <div className="overlay"></div>

      <div className="content">
        <h4 className="subheading">FRAMED BY NATURE</h4>

        <h1 className="heading">
          Experience Lonavalley
        </h1>

        <p className="description">
          From lush green valleys to luxury living —
          discover the beauty that awaits you at Lonavalley.
        </p>

        <div className="nav-buttons">
          <button className="nav-btn" onClick={prevSlide}>
            ‹
          </button>

          <button className="nav-btn" onClick={nextSlide}>
            ›
          </button>
        </div>
      </div>

      <div className="video-section">
        <h2 className="video-heading">
          Explore The Valley
        </h2>

        <div className="video-carousel">
          {videos.map((video, index) => {
            let position = "nextSlide";

            if (index === activeIndex) {
              position = "activeSlide";
            } else if (
              index === activeIndex - 1 ||
              (activeIndex === 0 &&
                index === videos.length - 1)
            ) {
              position = "prevSlide";
            }

            return (
              <div
                className={`video-card ${position}`}
                key={index}
              >
                <img
                  src={video.img}
                  alt={video.title}
                  loading="lazy"
                />

                <div className="video-info">
                  <p>{video.title}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Gallery;